import HeaderMenu from '../__header/headerMenu';
import MegaMenu from '../__header/MegaMenu';
import MobileHeader from '../__header/mobileHeader';
import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import Forms from '../__utils/forms';
import viewportUnits from '../__utils/viewportUnits';
import AlertBar from '../__header/AlertBar';
import Cookie from '../__footer/Cookie';
import { searchClear, searchHeightFunc } from '../__page/searchClear';
import a11yController from '../__utils/a11yController';

const headerMobile = new MobileHeader();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		HeaderMenu.init();
		MegaMenu.init();
		headerMobile.init();
		Video.init();
		mirrorHover();
		smoothScroll();
		Tables.init();
		viewportUnits();
		AlertBar();
		Cookie();
		searchClear();
		searchHeightFunc();
	},
	loaded() {
		document.querySelector('body').classList.add('page-has-loaded');
		Forms();
		viewportUnits();
		a11yController();
	},
	resized() {
		window.removeEventListener('resize', MegaMenu.init());
		window.removeEventListener('resize', headerMobile.init());
		HeaderMenu.removeEvents();
		headerMobile.resized();		
		//HeaderMenu.init();
		
		HeaderMenu.submitSearchForm();
		$('.btn-search').on('click', HeaderMenu.toggleSearchBar);
		$('.main-header__nav > .menu > .menu-item-has-children > a').on('click', HeaderMenu.toggleChildMenu);
		HeaderMenu.bindBackEvents();
		MegaMenu.init();
		headerMobile.init();
		Tables.toggleShadow();
		viewportUnits();
		searchHeightFunc();
	},
	scrolled() {},
	keyDown() {},
	mouseUp(e) {
		headerMobile.hideOutsideClick(e);
	},
};
export default controller;
